/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Request body parameter that contains details such as token and new password
 * @export
 * @interface ResetPassword
 */
export interface ResetPassword {
    /**
     * token value which will be generated as unique string that will be sent with email to allow user for completing reset-password operation
     * @type {string}
     * @memberof ResetPassword
     */
    token: string;
    /**
     * new password string which is required to complete process of resetting password
     * @type {string}
     * @memberof ResetPassword
     */
    newPassword: string;
}

/**
 * Check if a given object implements the ResetPassword interface.
 */
export function instanceOfResetPassword(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "newPassword" in value;

    return isInstance;
}

export function ResetPasswordFromJSON(json: any): ResetPassword {
    return ResetPasswordFromJSONTyped(json, false);
}

export function ResetPasswordFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPassword {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'newPassword': json['newPassword'],
    };
}

export function ResetPasswordToJSON(value?: ResetPassword | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'newPassword': value.newPassword,
    };
}

